<script lang="ts">
  /** 実行中・再試行の待機・判定を出せなかったエラーの表示（sandboxd-client.md §5） */
  import VerdictBadge from '../VerdictBadge.svelte';
  import type { RunState } from './run-state.svelte';

  interface Props {
    run: RunState;
    /** 実行中に出す文言 */
    busyLabel?: string;
    onretry?: (() => void) | undefined;
  }

  let { run, busyLabel = '判定中', onretry }: Props = $props();
</script>

{#if run.running}
  <div class="run-status" data-testid="run-status">
    <VerdictBadge verdict="pending" size="sm" />
    <span role="status">{run.retryMessage ?? `${busyLabel}です。`}</span>
    <button class="btn btn-sm" type="button" data-testid="run-cancel" onclick={() => run.cancel()}
      >やめる</button
    >
  </div>
{:else if run.error}
  <div class="run-status run-error" role="alert" data-testid="run-error">
    <span class="mark" aria-hidden="true">！</span>
    <span>{run.error.message}</span>
    {#if run.error.retry && onretry}
      <button class="btn btn-sm" type="button" data-testid="run-retry" onclick={() => onretry()}
        >再実行</button
      >
    {/if}
  </div>
{/if}

<style>
  .run-status {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    flex-wrap: wrap;
    font-size: var(--fs-sm);
    color: var(--text-soft);
  }
  .run-error {
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius-sm);
    background: var(--warn-bg);
    color: var(--warn-text);
  }
  .mark {
    font-weight: var(--fw-bold);
  }
</style>
